import './PracticeVideo.scss'

import React, { useState, useMemo } from 'react'
import { Col, Row, Container } from 'react-bootstrap'
import cn from 'classnames'

import ModalVideoPreview from '../../modal-video-preview'
import LessonVideo from '../../lessons/LessonVideo'
import WebShare from '../../web-share'
import Bookmark from 'components/bookmark/Bookmark'

export default function PracticeVideo({
  url,
  captionsUrl,
  isLargeScreen,
  children,
  data,
  practiceType
}) {
  const [showVideo, setShowVideo] = useState(false)
  const handleClose = () => setShowVideo(false)
  const handleShow = () => setShowVideo(true)

  const renderVideo = useMemo(
    () => (
      <LessonVideo
        video={{
          id: data.id,
          acf_extended: {
            video_url:
              data?.acf?.intro_video_url || data?.acf?.tutorial_video_url,
            captions_url:
              data?.acf?.captions_url || data?.acf?.tutorial_video_captions_url
          },
          poster:
            data?.featured_image_url ||
            'https://images.pexels.com/photos/268134/pexels-photo-268134.jpeg?auto=compress&cs=tinysrgb&w=1600'
        }}
        practiceType={practiceType}
      />
    ),
    [data, practiceType]
  )

  return !url ? null : (
    <div
      className={cn('video-wrapper practice-video', {
        'video-screen-modal': isLargeScreen
      })}
    >
      {isLargeScreen ? (
        <>
          <img
            src={
              data?.featured_image_url ||
              'https://images.pexels.com/photos/268134/pexels-photo-268134.jpeg?auto=compress&cs=tinysrgb&w=1600'
            }
            alt='Video preview'
            fetchpriority='high'
          />
          <div className='practice-video-container'>
            <Container>
              <Row className='flex-column'>
                <Col>
                  <h1 className='practice-video-container__header'>{`Introduction to ${
                    data?.title.rendered ?? data?.title
                  }`}</h1>
                </Col>
                <Col>
                  <div className='d-flex align-items-center'>
                    <div
                      onClick={handleShow}
                      className='play-button-box px-0 d-inline-flex justify-content-start align-items-center'
                    >
                      <span>
                        <i className='bi bi-play-fill'></i>
                      </span>
                      <span className='px-1'>
                        <b className='me-3'>Play introduction video</b>
                      </span>
                    </div>
                    <Bookmark
                      categoryObjectId={data?.id}
                      category={practiceType}
                    />
                    <WebShare
                      text={data?.title.rendered ?? data?.title}
                      size='fs-5'
                    />
                  </div>
                </Col>
              </Row>
              <Row className='mt-5'>{children}</Row>
            </Container>
          </div>
        </>
      ) : (
        <div className='small-video-screen'>
          {data && renderVideo}
          <h1 className='video-intro-header'>
            Introduction to
            <br />
            {data?.title.rendered ?? data?.title}
          </h1>
        </div>
      )}
      {showVideo && data && (
        <ModalVideoPreview
          showVideo={showVideo}
          onClose={handleClose}
          title={data?.title.rendered ?? data?.title}
          videoUrl={url}
          captionsUrl={captionsUrl}
        />
      )}
    </div>
  )
}
